var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarListadoHover68X56(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 58,
    viewBox: "0 0 68 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7698_243422)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7198 31.0999C33.7198 30.6857 34.0556 30.3499 34.4698 30.3499H39.0698C39.484 30.3499 39.8198 30.6857 39.8198 31.0999C39.8198 31.5141 39.484 31.8499 39.0698 31.8499H34.4698C34.0556 31.8499 33.7198 31.5141 33.7198 31.0999Z",
    fill: "CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7198 25.0999C33.7198 24.6857 34.0556 24.3499 34.4698 24.3499H40.4698C40.884 24.3499 41.2198 24.6857 41.2198 25.0999C41.2198 25.5141 40.884 25.8499 40.4698 25.8499H34.4698C34.0556 25.8499 33.7198 25.5141 33.7198 25.0999Z",
    fill: "CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9791 23.1186C32.2726 23.4109 32.2734 23.8858 31.9811 24.1793L29.2811 26.8893C29.1405 27.0303 28.9496 27.1097 28.7505 27.1099C28.5513 27.1101 28.3603 27.0311 28.2195 26.8902L26.9995 25.6702C26.7066 25.3773 26.7066 24.9025 26.9995 24.6096C27.2923 24.3167 27.7672 24.3167 28.0601 24.6096L28.7488 25.2983L30.9185 23.1206C31.2108 22.8271 31.6857 22.8262 31.9791 23.1186Z",
    fill: "CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9791 29.1086C32.2726 29.4009 32.2734 29.8758 31.9811 30.1693L29.2811 32.8793C29.1405 33.0203 28.9496 33.0997 28.7505 33.0999C28.5513 33.1001 28.3603 33.0211 28.2195 32.8802L26.9995 31.6602C26.7066 31.3673 26.7066 30.8925 26.9995 30.5996C27.2923 30.3067 27.7672 30.3067 28.0601 30.5996L28.7488 31.2883L30.9185 29.1106C31.2108 28.8171 31.6857 28.8162 31.9791 29.1086Z",
    fill: "CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.56 18.75C26.9035 18.75 24.75 20.9035 24.75 23.56V32.44C24.75 35.0965 26.9035 37.25 29.56 37.25H38.44C41.0965 37.25 43.25 35.0965 43.25 32.44V23.56C43.25 20.9035 41.0965 18.75 38.44 18.75H29.56ZM23.25 23.56C23.25 20.0751 26.0751 17.25 29.56 17.25H38.44C41.9249 17.25 44.75 20.0751 44.75 23.56V32.44C44.75 35.9249 41.9249 38.75 38.44 38.75H29.56C26.0751 38.75 23.25 35.9249 23.25 32.44V23.56Z",
    fill: "CurrentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7698_243422",
    x: -14,
    y: -10,
    width: 96,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.278431 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7698_243422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7698_243422",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarListadoHover68X56);
export default __webpack_public_path__ + "static/media/SIDEBAR_LISTADO_HOVER_68X56.4d2086965dd08f8a5ceb95da0c546e6e.svg";
export { ForwardRef as ReactComponent };